import(/* webpackMode: "eager" */ "/app/apps/legacy-frontend/src/app/page.tsx");
